 <template>
  <NLabelAndValue :label="$attrs.label">
    <template v-slot:valueContent>
      {{ hijriDate }}
      <span style="font-size: smaller; color: #435363">
        ({{ miladiDate }})
      </span>
    </template>
  </NLabelAndValue>
</template>
  
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

var moment = require("moment-hijri");
@Component({
  directives: {},
  components: {},
  diProvide: [],
})
export default class DateViewerComponent extends Vue {
  @Prop({ default: "" }) hijriCurrentDate!: string;
  @Prop({ default: "" }) miladiCurrentDate!: string;

  hijriDate: string | undefined = "";
  miladiDate: string = "";

  public mounted() {
    this.hijriDate = this.hijriCurrentDate + " هـ";
    this.miladiDate = this.miladiCurrentDate + " م";
  }
}
</script>

<style scoped>
</style>
